import { CALCULATOR_TYPES } from "constants/calculator";

export enum ActivePosition {
  Ten = 10,
  Twenty = 20,
  Thirty = 30,
}
export enum AnalyticsType {
  General = "general",
  Details = "details",
}

export type modalTypes = "details" | "pro" | "expert" | "pdf";

export type calculatorTypes = (typeof CALCULATOR_TYPES)[keyof typeof CALCULATOR_TYPES];

export type CalculatorWidgetProps = {
  formClassName?: string; 
  analyticsClassName?: string;
  documentDownloadLoading?: boolean;
  domainCheck: boolean;
  isAuthenticated: boolean;
  loading: boolean;
  submitLoading: boolean;
  activePosition: ActivePosition;
  analyticsType: AnalyticsType;
  energyEfficiencyClass: string;
  proCalculation: any;
  proCalculationCharts: any;
  calculation: any;
  lastCalculatorHistory: any;
  proCalculationDocument: any;
  initialType: calculatorTypes;
  onPositionChange: (position: ActivePosition) => void;
  onCalculationClick: (data: any, type: calculatorTypes) => void;
  onAnalyticsTypeChange: () => void;
  onCalculatorStepChange: () => void;
  onDownloadPDFClick: () => void;
};